import { FunctionComponent, useState } from 'react'
import { MdCheck, MdCloudDownload } from 'react-icons/md'

import Grid from '@material-ui/core/Grid'
import { IComprovanteTransferencia } from 'modules/pagamentos/domain/usecases/ComprovanteTransferencia'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'
import iconConcluido from 'shared/assets/icons/icon-concluido-blue.png'
import tmovLight from 'shared/assets/icons/tmov-logo-light.svg'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import { cnpjMask, cpfMask, numberToCurrency } from 'shared/utils/formatters'
import { encrypt } from 'shared/utils/crypt'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import {
  Container,
  Icon,
  StyleButton,
  Center,
  Logo,
  Content,
  Ticket,
  ContainerFooter,
} from './styles'

type TProp = {
  openModal: boolean
  setOpenModal: (openModal: boolean) => void
  comprovanteTransferencia: IComprovanteTransferencia
  nomeFavorecido: string
  cnpjFavorecido: string
  protocolo: string
  valor: number
}

interface ComprovanteTransferencia {
  protocolo: string
  cnpj: string
  valor: number
  favorecido: string
  agencia?: number
  nome_banco?: string
  conta?: number
}

const ModalTransferencia: FunctionComponent<TProp> = ({
  openModal,
  setOpenModal,
  comprovanteTransferencia,
  nomeFavorecido,
  cnpjFavorecido,
  protocolo,
  valor,
}) => {
  const { frotistaId } = useFrotista()

  const [loading, setLoading] = useState(false)
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const { setStep, setContaFavorecido, contaFavorecido } = useTransferencia()

  const handleCloseModal = () => {
    setOpenModal(false)
    setContaFavorecido(null)
    setStep(0)
    window.location.reload()
  }

  const handleDownloadModal = async () => {
    setLoading(true)
    try {
      const dadosComprovante: ComprovanteTransferencia = {
        protocolo,
        cnpj: cnpjFavorecido,
        valor,
        favorecido: nomeFavorecido,
        agencia: contaFavorecido ? contaFavorecido.agencia : 0,
        nome_banco: contaFavorecido ? contaFavorecido.nome_banco : '',
        conta: contaFavorecido ? contaFavorecido.conta : 0,
      }
      const encryptedData = encrypt(
        dadosComprovante,
        false,
        frotistaId.toString(),
      )
      const data = await comprovanteTransferencia.execute({
        data: encryptedData,
        frotista_id: frotistaId,
      })
      const file = new Blob([data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      setErrorMessage(
        'Não foi possível baixar o comprovante de transferência, por favor tente novamente em alguns minutos.',
      )
      setOpenErrorMessage(true)
    }
  }

  return (
    <Modal size="large" openModal={openModal} showCloseButton={false}>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      <Container>
        <Icon src={iconConcluido} />

        <Text color={colors.blue} weight={'700'} size={20}>
          Transferência concluída!
        </Text>

        <div>
          <Center>
            <Text color={colors.green} weight={'700'} size={18}>
              Comprovante
            </Text>
          </Center>
          <Ticket>
            <Center style={{ marginBottom: 5 }}>
              <Text color={colors.black} weight={'500'} size={11}>
                {new Date().toLocaleString('pt-BR')}
              </Text>
            </Center>
            <Center>
              <Text color={colors.black} weight={'500'} size={11}>
                Transferência efetuada com sucesso
              </Text>
            </Center>

            <Center>
              <Logo src={tmovLight} />
            </Center>
            <Content>
              <Text color={colors.black} weight={'500'} size={11}>
                Favorecido
              </Text>
              <Text color={colors.black} weight={'500'} size={11}>
                {nomeFavorecido ? nomeFavorecido.toUpperCase() : ''}
              </Text>
              <Text color={colors.black} weight={'500'} size={11}>
                {cnpjFavorecido
                  ? cnpjFavorecido.length === 11
                    ? cpfMask(cnpjFavorecido)
                    : cnpjMask(cnpjFavorecido)
                  : ''}
              </Text>
              {contaFavorecido?.nome_banco && (
                <Text color={colors.black} weight={'500'} size={11}>
                  {`${contaFavorecido?.nome_banco} | AG: ${contaFavorecido?.agencia} | CC: ${contaFavorecido?.conta}`}
                </Text>
              )}
            </Content>
            <Content>
              <Text color={colors.black} weight={'500'} size={11}>
                PROTOCOLO: {protocolo}
              </Text>
              <ContainerFooter>
                <Text color={colors.black} weight={'500'} size={11}>
                  VALOR DA TRANSFERÊNCIA:
                </Text>
                <Text color={colors.black} weight={'500'} size={11}>
                  {valor ? numberToCurrency(valor) : ''}
                </Text>
              </ContainerFooter>
            </Content>
          </Ticket>
        </div>

        <Grid container>
          <StyleButton color={colors.orange} onClick={handleCloseModal}>
            <MdCheck />
            Concluir
          </StyleButton>
          <StyleButton color={colors.green} onClick={handleDownloadModal}>
            <MdCloudDownload />
            Baixar
          </StyleButton>
        </Grid>
      </Container>
    </Modal>
  )
}

export default ModalTransferencia
